const Keys = {
  TAB: 'Tab',
  ENTER: 'Enter',
  ESCAPE: 27,
  UP: 38,
  DOWN: 40
}

export default Keys
